
<style lang="scss">
    .action-container{
        .ivu-btn:hover{
            color: #6d7380;
        }
        .ivu-badge-count{
            min-width: 15px;
            height: 15px;
            right: 10px;
            line-height: 14px;
            padding: 0px 0px;  
            font-size: 10px;
        }
    }
    .demo-badge{
        background: #eee;
        border-radius: 6px;
        display: inline-block;
    }
    .action-btn{
        background-color: #f7f7f7 !important;
        -webkit-box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.6) !important;
        -moz-box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.6) !important;
        -o-box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.6) !important;
        box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.6) !important;
    }
    .action-avatar > img {
        margin-top:8px  !important;
        height:15px !important;
        width:15px  !important;
    }

</style>

<template>
    <div style="z-index: 8;padding:0 0 8px; position:relative">
        <Row  class="action-container"  type="flex" justify="center" :gutter="8">
            <Col v-if="!isBroadcast && !isDocuments">
                <!-- <Button v-if="!islikeLoading" @click="onLike" :style="{'color': showLike ? 'rgb(45, 140, 240)' : ''}"  class="action-btn" shape="circle" icon="thumbsup"></Button> -->
                <span v-if="!islikeLoading">
                    <!-- <Button v-if="!islikeLoading && showLike" @click="onLike" :style="{'color': showLike ? 'rgb(45, 140, 240)' : ''}"  class="action-btn" shape="circle" icon="thumbsup"></Button> -->
                    <a @click="onLike" v-if="!islikeLoading && showLike" >
                        <Avatar class="action-avatar action-btn" :src="likeSolidImg" ></Avatar>
                    </a>
                    <a @click="onLike" v-if=" !islikeLoading && !showLike" >
                        <Avatar class="action-avatar action-btn" :src="likeImg" ></Avatar>
                    </a>
                </span>
                <Button v-if="islikeLoading" class="action-btn" shape="circle" :loading="true"></Button>
                <Badge :count="likeCount" v-if="!islikeLoading">
                    <span class="demo-badge"></span>
                </Badge>
            </Col>
            <Col v-if="!isBroadcast && !isDocuments">
                <a @click="onCommentOpen">
                    <Avatar class="action-avatar action-btn" :src="commentImg" ></Avatar>
                </a>
                <span @click="onCommentOpen">
                <Badge :count="commentCount">
                    <span class="demo-badge"></span>
                </Badge>
                </span>
                <!-- <Button @click="onShare" class="action-btn" shape="circle" icon="android-share-alt"></Button>     -->
            </Col>
            <Col v-if="likeCount > 0 && false && !isDocuments">
                <Button @click="onLikeOpen" class="action-btn" shape="circle" icon="chatbox"></Button>
                <span @click="onLikeOpen">
                <Badge :count="likeCount">
                    <span class="demo-badge"></span>
                </Badge>
                </span>
            </Col>
            <Col v-if="showShare && !isDocuments">
                <a @click="onShare">
                    <Avatar class="action-avatar action-btn" :src="shareImg" ></Avatar>
                </a>
                <!-- <Button @click="onShare" class="action-btn" shape="circle" icon="android-share-alt"></Button>     -->
            </Col>
            <Col v-if="!isBroadcast">
                <!-- <Button @click="onBookmark" :style="{'color': isBookmarked != 0 ? 'rgb(45, 140, 240)' : ''}" style="background-color: white;-webkit-box-shadow: 1px 2px 6px 0px rgba(0,0,0,0.6);"  shape="circle" icon="bookmark"/> -->
                <div v-if="!bookmarkLoading">    
                    <a  @click="onBookmark" v-if="isBookmarked" >
                        <Avatar class="action-avatar  action-btn" :src="bookmarkSolidImg"></Avatar>
                    </a>
                    <a  @click="onBookmark" v-else>
                        <Avatar class="action-avatar action-btn" :src="bookmarkImg" ></Avatar>
                    </a>
                </div>
                <Button v-else  class="action-btn" shape="circle" :loading="true"></Button>                       
            </Col>
            <Col v-if="!isBroadcast && !isDocuments">
                <!-- <Button @click="onReport" class="action-btn" shape="circle" icon="alert"></Button>     -->
                <a @click="onReport">
                    <Avatar class="action-avatar action-btn" :src="reportImg" ></Avatar>
                </a>                
            </Col>
            <Col v-if="false">
                <Button @click="onEdit" class="action-btn" shape="circle" icon="edit"></Button>
            </Col>
            <Col v-if="isAdmin">
                <Button @click="onDelete" class="action-btn" shape="circle" icon="ios-trash-outline"></Button>
            </Col>
        </Row>
    </div>
</template>

<script>
import likeImg from '@/assets/svg/thumbs-up-regular.svg'
import likeSolidImg from '@/assets/svg/thumbs-up-solid.svg'
import bookmarkImg from '@/assets/svg/bookmark-regular.svg'
import bookmarkSolidImg from '@/assets/svg/bookmark-solid.svg'
import shareImg from '@/assets/svg/share-outline.svg'
import reportImg from '@/assets/svg/error-outline.svg'
import commentImg from '@/assets/svg/comment-regular.svg'
import { mapGetters } from 'vuex'

export default {
    data() {
        return { 
            likeImg,
            likeSolidImg,
            shareImg,
            bookmarkImg,
            bookmarkSolidImg,
            reportImg,
            commentImg
        };
    },
    props: {
        showLike: Boolean,
        likeCount: Number, default: 0,
        showShare: Boolean,
        isBookmarked: Number,
        commentCount: Number, default: 0,
        isAdmin: Boolean,
        isDocuments: Boolean, default: false
    },
    methods:{
        onLike () {
            this.$emit('likeBtn')
        },
        onCommentOpen () {
            this.$emit('showCommentMenu')
        },
        onShare () {
            this.$emit('share')
        },
        onBookmark () {
            this.$emit('bookmark')
        },
        onReport () {
            this.$emit('report')
        },        
        onEdit () {
            this.$emit('edit')
        },
        onDelete () {
            this.$emit('delete')
        }
    },
    computed:{
        ...mapGetters("user", ["isBroadcast"]),
        bookmarkLoading: {
            get() {
                return this.$store.state.feed.isBookmarkLoading
            }
        },
        islikeLoading:{
            get(){
                return this.$store.state.feed.activityLikes.isLikeActivityLoading
            }
        }
    }
}
</script>


